module.exports = __webpack_public_path__ + "media/images/front/pc/institution-search/female-dcd74dbf940a23dfe8f9ec655ce29911.svg";